import { createFileRoute } from '@tanstack/react-router';

import { blockKindParamSchema, SharedBlockCreateKindPage } from '@/features/content';

/** `banner` or `rail`; anything else fails to parse and renders the route error. */
export const Route = createFileRoute('/_authed/_active/org/shared-blocks/new/$kind')({
  params: {
    parse: (raw) => ({ kind: blockKindParamSchema.parse(raw.kind) }),
    stringify: (params) => ({ kind: params.kind }),
  },
  component: SharedBlockCreateKindPage,
});
